import type { WebapiEndpointBuilder } from '@/api/webapi.ts';
import { closeFlexiForwardRfs } from '@/store/flexi-forward/api/requestFlexiForwardRfs.ts';

export function cancelFlexiForwardRfs(builder: WebapiEndpointBuilder) {
  return builder.mutation<void, { rfsId: string; tileId: string; removeQuote?: boolean }>({
    query: (params) => {
      const rfsId = params.rfsId;

      return {
        url: '/fxoAmericanForward/rfs/cancel',
        method: 'POST',
        body: { rfsId },
        headers: {
          'X-Correlation-Id': rfsId,
        },
      };
    },

    onQueryStarted({ tileId }, { dispatch }) {
      closeFlexiForwardRfs(tileId, dispatch);
    },
  });
}
